export const DISTRIBUTOR_TYPE_MESSAGES_SUCCESS = {
  SAVE_SUCCESS: "Tipo de distribuidor guardado exitosamente.",
  DISABLE_SUCCESS: "Tipo de distribuidor deshabilitado exitosamente.",
  ENABLE_SUCCESS: "Tipo de distribuidor habilitado exitosamente.",
};

export const DISTRIBUTOR_TYPE_MESSAGES_ERROR = {
  SAVE_ERROR:
    "Error al guardar el tipo de distribuidor. Por favor, inténtalo de nuevo.",
  DISABLE_ERROR:
    "Error al deshabilitar el tipo de distribuidor. Por favor, inténtalo de nuevo.",
  ENABLE_ERROR:
    "Error al habilitar el tipo de distribuidor. Por favor, inténtalo de nuevo.",
};
